// /Users/pramod/Desktop/school-erp/frontend/src/Tenant/TenantWebsite/components/ImageModal.js

import React, { useEffect } from 'react';
import { FiX as CloseIcon, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import buildResolvedFile from '../utils/buildResolvedFile';

const ImageModal = ({
  images = [],
  currentIndex = 0,
  onClose = () => {},
  onNavigate = () => {},
  apiBaseURL = ''
}) => {
  const idx = Math.max(0, Math.min(images.length - 1, currentIndex));
  const item = images[idx] || {};
  const src = buildResolvedFile(
    item.url || item.src || item.image || '',
    apiBaseURL
  ).resolvedSrc || item.url || item.src || item.image || '';

  // Keyboard navigation
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onNavigate(idx - 1);
      if (e.key === 'ArrowRight') onNavigate(idx + 1);
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [idx, onClose, onNavigate]);

  if (!item) return null;

  const hasPrevious = idx > 0;
  const hasNext = idx < images.length - 1;

  return (
    <div className="fixed inset-0 z-60 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md">
      <div className="relative max-w-6xl w-full max-h-[90vh]">
        {/* Close Button */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-0 right-0 z-20 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white/60 hover:text-white"
        >
          <CloseIcon className="w-5 h-5" />
        </button>

        {/* Image Counter */}
        <div className="absolute top-0 left-0 z-20 px-4 py-2 rounded-full bg-black/50 backdrop-blur-sm text-white/60 text-xs font-medium">
          {idx + 1} / {images.length}
        </div>

        {/* Navigation Buttons */}
        {hasPrevious && (
          <button
            onClick={() => onNavigate(idx - 1)}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white/60 hover:text-white ml-2"
            aria-label="Previous"
          >
            <FiChevronLeft className="w-6 h-6" />
          </button>
        )}

        {hasNext && (
          <button
            onClick={() => onNavigate(idx + 1)}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white/60 hover:text-white mr-2"
            aria-label="Next"
          >
            <FiChevronRight className="w-6 h-6" />
          </button>
        )}

        {/* Image */}
        <div className="flex items-center justify-center h-full">
          <div className="relative max-h-[80vh] overflow-hidden rounded-xl bg-black/30">
            {src ? (
              <img
                src={src}
                alt={item.caption || `image-${idx}`}
                className="w-auto h-auto max-h-[80vh] max-w-full object-contain"
              />
            ) : (
              <div className="w-full h-96 flex items-center justify-center text-white/40">
                No image available
              </div>
            )}
          </div>
        </div>

        {/* Caption */}
        {item.caption && (
          <div className="mt-4 text-center">
            <p className="text-white/60 text-sm font-light max-w-2xl mx-auto">
              {item.caption}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal;